import { generateStorefrontChildPages } from 'utils/generateStorefrontPage';

const SLUG = 'partners';

const PartnersPage = generateStorefrontChildPages(SLUG);

const { getStaticProps, getStaticPaths, Page } = PartnersPage;

export { getStaticProps, getStaticPaths };
export default Page;
